/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
    'send_to': 'AW-785293729/7v6-CJf6grMDEKHDuvYC',
    'event_callback': callback
  });
  return false;
}

document.addEventListener('product:added', function(event) {
  gtag('event', 'conversion', {
    'send_to': 'AW-785293729/omfQCMLQs7MDEKHDuvYC'
  });
});


/* MCC detailing services in the basket (added 2 Oct 2026):
   - show the service name only, without the length and size (e.g. "– 2 working days (32 hrs) / Large");
     the booking, vehicle size and collection lines are shown underneath
   - show the same quantity box as other products, fixed at 1 (one booking per vehicle) */
(function () {
  var LEN = /\s[-–]\s.*$/;
  function qtyBox() {
    var minus = document.querySelector('.quantity-selector__button svg.icon--minus');
    var plus = document.querySelector('.quantity-selector__button svg.icon--plus');
    var m = minus ? minus.outerHTML : '<svg focusable="false" class="icon icon--minus" viewBox="0 0 10 2"><path fill="currentColor" d="M10 0v2H0V0z"></path></svg>';
    var p = plus ? plus.outerHTML : '<svg focusable="false" class="icon icon--plus" viewBox="0 0 10 10"><path fill="currentColor" d="M6 4h4v2H6v4H4V6H0V4h4V0h2v4z"></path></svg>';
    var d = document.createElement('div');
    d.className = 'quantity-selector mcc-service-qty';
    d.title = 'One booking per vehicle';
    d.innerHTML = '<button type="button" class="quantity-selector__button" disabled tabindex="-1" aria-hidden="true">' + m + '</button>' +
      '<input class="quantity-selector__value" value="1" size="2" readonly disabled aria-label="Quantity: 1">' +
      '<button type="button" class="quantity-selector__button" disabled tabindex="-1" aria-hidden="true">' + p + '</button>';
    return d;
  }
  function tidy() {
    document.querySelectorAll('a[href*="/products/detailing-"]').forEach(function (a) {
      if (!a.matches('.line-item__title, .mini-cart__product-title')) return;
      var member = a.href.indexOf('/products/detailing-membership-') !== -1;
      // Memberships keep the plan and size in the title (e.g. "Detailing Membership – Premium - Small & Medium").
      if (!member && LEN.test(a.textContent)) a.textContent = a.textContent.replace(LEN, '');
      var item = a.closest('.line-item, .mini-cart__line-item, tr, li');
      if (!item) return;
      // The subscription app names its monthly plan "Deliver every month"; for a service say "Billed monthly".
      if (member) item.querySelectorAll('p, span, div').forEach(function (el) {
        if (el.children.length === 0 && /^\s*Deliver every month\s*$/i.test(el.textContent)) el.textContent = 'Billed monthly';
      });
      item.querySelectorAll('.line-item__quantity-remove, .mini-cart__quantity-remove').forEach(function (rm) {
        var box = rm.parentNode;
        if (box.querySelector('.quantity-selector')) return;
        var span = rm.previousElementSibling;
        if (span && span.tagName === 'SPAN' && /^\s*\d+\s*$/.test(span.textContent)) span.remove();
        box.insertBefore(qtyBox(), rm);
      });
    });
  }
  var t = null;
  function soon() { clearTimeout(t); t = setTimeout(tidy, 50); }
  document.addEventListener('DOMContentLoaded', tidy);
  if (document.readyState !== 'loading') tidy();
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].addedNodes.length) { soon(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
